export function copy<T>(object: T): T {
  return JSON.parse(JSON.stringify(object)) as typeof object
}
